// 2d和3d地图
export default {
    namespaced: true,
    state: {
        ready: false,
        map2dChanged: null
    },
    mutations: {
        setReadyState(state, ready) {
            state.ready = ready
        },
        setMap2dChanged(state) {
            state.map2dChanged = new Date().getMilliseconds()
        }
    }
}
